/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_Meta_TitleInputs */

const en_simple_oto_meta_title = /** @type {(inputs: Simple_Oto_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep builds your app`)
};

const id_simple_oto_meta_title = /** @type {(inputs: Simple_Oto_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep membangunkan aplikasimu`)
};

/**
* | output |
* | --- |
* | "Bystep builds your app" |
*
* @param {Simple_Oto_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_meta_title = /** @type {((inputs?: Simple_Oto_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_meta_title(inputs)
	return en_simple_oto_meta_title(inputs)
});